export default {
    intro: 'ดูเบาะแสอย่างพยัญชนะต้น ความหมาย ประโยคตัวอย่าง<br />แล้วลองเดาว่าเป็นคำใดดูสิ!',
    word: 'คำ',
    meaning: 'ความหมาย',
    example: 'ตัวอย่าง',
    resources: 'สื่อ',
    teacherFooter: {
        left: 'กรุณาเลือกคำจากโจทย์ทางซ้าย',
    },
    emptyExample: 'ไม่มีประโยคตัวอย่าง',
    openExample: 'เมื่อเปิดประโยคตัวอย่าง คำจะถูกเปิดเผยทั้งหมด',
    introSelectWord: 'เลือกคำทางซ้ายเพื่อเริ่มกันเลย!',
    subExamplesExpand: 'ดูประโยคตัวอย่างเสริมเพิ่มเติม',
    subExamplesCollapse: 'พับ',
    showInitial: 'แสดงพยัญชนะต้น',
    showAll: 'แสดงทั้งหมด',
    show: 'แสดง',
    answerPlaceholder: 'กรอกคำตอบ',
    meMark: 'ฉัน',
    table: {
        question: 'โจทย์',
        emptyMessage: 'ไม่มีเนื้อหา',
    },
    teacher: {
        inplay: {
            hintLabel: 'คำใบ้พยัญชนะต้น',
            quizStart: 'เริ่มควิซ',
            quizActive: 'ควิซกำลังดำเนินอยู่',
            wordOpen: 'เปิดคำ',
            dictionaryExamples: 'ประโยคตัวอย่างจากพจนานุกรม {count} ประโยค',
            collapse: 'ปิด',
            expand: 'ดูเพิ่มเติม',
            readyTitle: 'พร้อมแล้ว',
            readyMessage: 'เมื่อคุณครูเปิดเบาะแส จะปรากฏที่นี่',
        },
        modal: {
            clearConfirm: {
                title: 'จะล้างคำศัพท์ที่รออยู่ทั้งหมดไหม?',
                message: 'คำศัพท์ที่รอลงทะเบียนจะถูกลบทั้งหมด ต้องการดำเนินการต่อหรือไม่?',
            },
            closeConfirm: {
                title: 'จะลบโจทย์ที่กรอกไว้ไหม?',
                message: 'หากปิด คำศัพท์ในคิวจะหายไปทั้งหมด ต้องการดำเนินการต่อหรือไม่?',
            },
            questionDelete: {
                title: 'จะลบโจทย์ไหม?',
                // {word}: 삭제 대상 문항의 표제어. 활동에서 영구 제거됨을 안내.
                message: "โจทย์ '{word}' จะถูกลบออกจากกิจกรรม ต้องการดำเนินการต่อหรือไม่?",
            },
            waitItemDelete: {
                title: 'จะลบคำศัพท์ที่รออยู่ไหม?',
                // {word}: 삭제 대상 대기 어휘. 대기열에서만 제거되며 활동에는 영향 없음을 안내.
                message: "จะลบ '{word}' ออกจากคิว ต้องการดำเนินการต่อหรือไม่?",
            },
            // {count}: BE가 사전 중복으로 건너뛴 어휘 수
            duplicateNotice: 'คำศัพท์ {count} คำที่ลงทะเบียนไว้แล้วไม่ถูกเพิ่ม',
            // {count}: 뜻이 없어 등록 불가로 건너뛴 어휘 수
            skippedNotice: 'คำศัพท์ {count} คำไม่ถูกลงทะเบียนเพราะไม่มีความหมาย',
            // 혼합(뜻없는 어휘 + 뜻있는 어휘) 등록 시 확인 모달
            mixedEmptyConfirm: {
                title: 'จะลงทะเบียนไหม?',
                // {empty}: 뜻 비어 등록 불가 개수
                line1: 'คำศัพท์ {empty} คำที่ไม่มีความหมายจะไม่ถูกเพิ่ม',
                // {valid}: 실제 등록될 개수
                line2: 'จะลงทะเบียนเฉพาะ {valid} คำที่เหลือในกิจกรรมไหม?',
            },
            // 뜻없는 어휘만 있을 때 등록 불가 안내
            onlyEmptyNotice: {
                title: 'ไม่สามารถลงทะเบียนได้',
                message: 'ไม่มีคำศัพท์ที่ลงทะเบียนได้ เหลือแต่คำศัพท์ที่ไม่มีความหมายเท่านั้น',
            },
            registerFailed: 'ลงทะเบียนไม่สำเร็จ',
        },
    },
};
